import CanalModel from './CanalModel'
import TiposDeCanaisEnum from './TiposDeCanaisEnum'

export default class CanalAberturaManualModel extends CanalModel {
  constructor({
    id = 0,
    nome = '',
    descricao = '',
  } = {}) {
    super(id, nome, descricao, TiposDeCanaisEnum.AberturaManual)
  }
}
